import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight, ShieldCheck } from "lucide-react";
import { useAdmin } from "../../contexts/AdminContext";
import Navbar from "../../components/feature/Navbar";

export default function AdminLogin() {
  const { settings } = useAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Vérification dynamique via settings admin
    setTimeout(() => {
      if (email === settings.adminEmail && password === settings.adminPassword) {
        localStorage.setItem("admin_auth", "true");
        navigate("/admin");
      } else {
        setError("Identifiants incorrects. Veuillez réessayer.");
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <main className="min-h-screen bg-slate-900 font-inter flex flex-col items-center justify-center p-6 bg-[radial-gradient(circle_at_50%_50%,_rgba(247,57,45,0.1)_0%,_transparent_50%)]">
      <Navbar />

      <div className="w-full max-w-md">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 p-8 rounded-3xl shadow-2xl">
          <div className="flex flex-col items-center text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-xl shadow-primary/25 mb-4">
              <ShieldCheck className="text-white" size={32} />
            </div>
            <h1 className="text-2xl font-bold text-white font-playfair uppercase tracking-widest">
              Admin-Zugang
            </h1>
            <p className="text-slate-400 text-sm mt-2">
              Loggen Sie sich ein, um die Verlosungen zu verwalten.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-1.5 ml-1">E-Mail</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-12 py-3.5 text-white focus:outline-none focus:border-primary focus:bg-white/10 transition-all font-medium"
                  placeholder="admin@beispiel.de"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-1.5 ml-1">Passwort</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-12 py-3.5 text-white focus:outline-none focus:border-primary focus:bg-white/10 transition-all font-medium"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/20 text-red-500 text-xs font-bold px-4 py-3 rounded-xl transition-all">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark disabled:bg-primary/50 text-white font-bold py-4 rounded-xl transition-all shadow-lg hover:shadow-primary/25 hover:-translate-y-0.5 group"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              ) : (
                <>
                  Zum Dashboard anmelden
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </>
              )}
            </button>
          </form>

          <div className="mt-8 pt-8 border-t border-white/5 text-center">
            <p className="text-slate-500 text-xs">
              Zugang nur für autorisiertes Personal.<br />
              <span className="text-slate-600 italic">Version 1.0.4</span>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
